module.exports = "\r\n  <ion-list-header>When you're happy with the position of your media, just double click the VR scene!</ion-list-header>\r\n"